import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import { useTranslation } from 'react-i18next';

// Components 

import FoldersList from './FoldersList';

// Props type definition
interface NavigationColumnProps {
    isMobile: boolean;
}

const NavigationColumn: React.FC<NavigationColumnProps> = ({ isMobile }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation();

    const colors = useAppSelector(state => state.theme.colors); 
    const mode = useAppSelector(state => state.fileExplorer.mode); 

    // Define width and height based on isMobile prop
    const width = isMobile ? '95%' : '25%'; // Full width on mobile, 25% on desktop
    const height = isMobile ? '20%' : '95%'; // Shorter on mobile (column layout), taller on desktop (row layout)
    const maxHeight = isMobile ? '300px' : undefined; // Max height on mobile if needed
    const margin = isMobile ? 1 : 1; // Consistent margin/padding
    const padding = isMobile ? 1 : 0; // Add padding on mobile

    return (

        <Box sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center', 
            width: width,
            height: height, 
            maxHeight: maxHeight,
            borderRadius: isMobile ? 1 : 2, // Smaller radius on mobile
            backgroundColor: colors?.container,
            overflowY: 'auto', // Ensure vertical scrolling is enabled
            overflowX: 'hidden',
            transition: 'width 0.3s, height 0.3s',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)', // Slightly softer shadow
            margin: margin, // Add margin for spacing in both layouts
            padding: padding, // Add padding on mobile
            flexShrink: 0, // Prevent shrinking in flex container
        }}>

            <FoldersList />
            
        </Box>

    );

};

export default NavigationColumn;